import './Testimonials.css';

export default function Testimonials() {
  return (
    <section className="dh-testimonials" id="reviews">
      <div className="dh-testimonials__map" aria-hidden />
      <div className="dh-container dh-testimonials__inner">
        <h2>what our clients say</h2>
        <blockquote>
          “Switching to Dragon was the best decision I made for my practice notes. Dragon Help walked
          me through mic setup and a stubborn launch error in one call — dictation has been smooth
          ever since.”
        </blockquote>
        <p className="dh-testimonials__by">— Clinic operations lead, verified customer</p>
        <img
          className="dh-testimonials__photo"
          src="/images/desk.jpg"
          alt="Professionals collaborating at a workstation"
          width="720"
          height="280"
        />
      </div>
    </section>
  );
}
